/**
 * Utilitários de formatação de data para exibição na UI.
 *
 * IMPORTANTE: Postgres retorna colunas DATE como string "YYYY-MM-DD" (sem hora).
 * O construtor `new Date("YYYY-MM-DD")` interpreta esse valor como UTC 00:00,
 * o que em America/Sao_Paulo (UTC-3) vira o dia anterior às 21:00, exibindo
 * data errada. Por isso tratamos DATE puro como local-date sem conversão.
 */

/**
 * Formata uma data ISO/DATE para o padrão pt-BR (dd/mm/aaaa).
 * - Aceita `YYYY-MM-DD` (DATE puro do Postgres) sem aplicar timezone.
 * - Aceita timestamp ISO completo; nesse caso usa a timezone local do navegador.
 * - Retorna "—" para valores vazios/nulos.
 */
export function formatDateBR(iso: string | null | undefined): string {
  if (!iso) return "—";
  // DATE puro: "2026-06-15" — evita o bug de conversão UTC→local
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  // Timestamp completo: deixa o navegador formatar com a timezone do usuário
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("pt-BR");
}
